export const consumption = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
    	consumption_management:'Consumption Management',
        consumption_view:'Consumption View',
        view_consumption_data:'View Consumption Data',
        device_consumption_data:'Device Consumption Data',
        update_consumption:'Update Consumption',
    	consumer_id:'Consumer ID',
        consumer_name:'Consumer Name',
        customer_name:'Customer Name',
    	date:'Date',
        time:'Time',
    	meter:'Meter',
        meter_reading:'Meter Reading',
    	opening_balance:'Opening Balance',
    	lora_data:'Lora Data',
    	colsing_balance:'Colsing Balance',
    	manual_adjustment:'Manual Adjustment',
    	consumption:'Consumption',
    	status:'Status',
        amr_data:'AMR Data',
        zone:'Zone',
        area:'Area',
        device_id:'Device Id',
        device_status:'Device Status',
        details:'Details',
        falt_no:'Flat No',
        tower_name:'Tower Name',
        total_consumption:'Total Consumption',
        site:'Site',
        city:'City',
        date_and_time:'Date & Time',
        meter_reading_scm:'Meter Reading (SCM)',
        view:'View',
        battery_value:'Battery Value',
        tamper_code:'Tamper Code',
        manual_adjust_history:'Manual Adjust History',
        created_date:'Created Date',
        add_manual_adjustment:'Add Manual Adjustment',
        manual_adjustment_history:'Manual Adjustment History',
        select_mode:'Select Mode',
        historical_device_data:'Historical Device Data',
    },

    ar: {
    	consumption_management:'إدارة الاستهلاك',
        consumption_view:'عرض الاستهلاك',
        view_consumption_data:'عرض بيانات الاستهلاك',
        device_consumption_data:'بيانات استهلاك الجهاز',
        update_consumption:'تحديث الاستهلاك',
    	consumer_id:'هوية المستهلك',
        consumer_name:'اسم المستهلك',
        customer_name:'اسم الزبون',
    	date:'التاريخ',
        time:'الوقت',
    	meter:'العداد',
        meter_reading:'قراءة العداد',
    	opening_balance:'الرصيد الافتتاحي',
    	lora_data:'الرصيد الختامي',
    	colsing_balance:'الرصيد النهائي',
    	manual_adjustment:'تعديل يدوي',
    	consumption:'الإستهلاك',
    	status:'الحالة',
        amr_data:'بيانات AMR',
        zone:'نطاق',
        area:'منطقة',
        device_id:'هوية الجهاز',
        device_status:'حالة الجهاز',
        details:'التفاصيل',
        falt_no:'رقم الشقة',
        tower_name:'اسم البرج',
        total_consumption:'إجمالي الاستهلاك',
        site:'الموقع',
        city:'المدينة',
        date_and_time:'التاريخ والوقت',
        meter_reading_scm:'قراءة العداد (SCM)',
        view:'عرض',
        battery_value:'قيمة البطارية',
        tamper_code:'كود التلاعب',
        manual_adjust_history:'سجل الضبط اليدوي',
        created_date:'تاريخ الإنشاء',
        add_manual_adjustment:'أضف التعديل اليدوي',
        manual_adjustment_history:'سجل التعديل اليدوي',
        select_mode:'حدد الوضع',
        historical_device_data:'بيانات الجهاز التاريخية',
    },
}